import { Toast } from "../../utils/Toast";

async function copyText(text: string, input: HTMLInputElement): Promise<boolean> {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            // insecure/local browser context: use the selection fallback below
        }
    }

    const active = document.activeElement as HTMLInputElement | null;
    input.focus();
    input.select();
    const copied = document.execCommand("copy");
    if (active && typeof active.focus === "function") active.focus();
    return copied;
}

export const AdminMailSettingsController = {
    edit(): void {
        document.querySelectorAll<HTMLElement>("[data-password-copy]").forEach((root) => {
            if (root.dataset.passwordCopyInited === "1") return;
            root.dataset.passwordCopyInited = "1";

            const input = root.querySelector<HTMLInputElement>("[data-password-copy-input]");
            const button = root.querySelector<HTMLButtonElement>("[data-password-copy-button]");
            if (!input || !button) return;

            button.addEventListener("click", async () => {
                const value = input.value;
                if (!value) {
                    Toast.error("복사할 앱 비밀번호가 없습니다.");
                    input.focus();
                    return;
                }
                const copied = await copyText(value, input);
                if (copied) {
                    Toast.success("앱 비밀번호를 복사했습니다.");
                } else {
                    Toast.error("앱 비밀번호 복사에 실패했습니다.");
                }
            });
        });
    },
    update(): void {},
    test(): void {},
};
